<template>
  <b-icon-pin-angle-fill
    :color="isPinned ? '#E2037E' : '#A4A5A5'"
    class="pin-icon" />
</template>

<script>
export default {
  props: {
    isPinned: {
      type: Boolean,
      required: true
    },
    white: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _isPinned() {
      if (this.white) {
        return this.isPinned ? '#E2037E' : '#FFF'
      }
      return this.isPinned ? '#E2037E' : '#A4A5A5'
    }
  }
}
</script>